<template>

    <div>

        <div class="m-5">

            <div class="mb-1 text-gray-600">Verticale marge</div>

            <small class="block mb-3 text-gray-500 text-muted">
                Dit is de (wit)ruimte tussen blokken aan de boven- en onderkant.
            </small>

            <select
                class="focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid ease-in-out mt-1 px-3 py-2 rounded-md shadow-sm transition w-full"
                @input="$set(options, 'margin', $event.target.value)"
                v-model="options.margin">
                <option v-for="option in margins" :value="option.value">{{ option.text }}</option>
            </select>

        </div>

        <div class="m-5">

            <div class="mb-1 text-gray-600">Horizontale marge</div>

            <small class="block mb-3 text-gray-500 text-muted">
                Dit is de (wit)ruimte links en rechts van het blok.
            </small>

            <select
                class="focus:border-blue-300 focus:outline-none focus:shadow-outline-blue form-control form-input sm:leading-5 sm:text-sm border border-gray-300 border-solid ease-in-out mt-1 px-3 py-2 rounded-md shadow-sm transition w-full"
                @input="$set(options, 'horizontalMargin', $event.target.value)"
                v-model="options.horizontalMargin">
                <option v-for="option in horizontalMargins" :value="option.value">{{ option.text }}</option>
            </select>

        </div>

    </div>

</template>

<script>

export default {

    props: {
        options: Object,
    },

    data()
    {
        return {
            // TODO Medium: Read TW prefix from tailwind.config.website.js
            margins: [
                {
                    'text': 'Geen',
                    'value': 'size:none',
                },
                {
                    'text': 'Klein',
                    'value': 'py-2 md:py-4 size:small',
                },
                {
                    'text': 'Middel',
                    'value': 'py-4 md:py-8 size:medium',
                },
                {
                    'text': 'Groot',
                    'value': 'py-8 md:py-16 size:large',
                },
                {
                    'text': 'Extra groot',
                    'value': 'py-16 md:py-32 size:extra-large',
                },
            ],

            horizontalMargins: [
                {
                    'text': 'Geen',
                    'value': 'horizontal-margin-size:none',
                },
                {
                    'text': 'Klein',
                    'value': 'horizontal-margin-size:small',
                },
                {
                    'text': 'Middel',
                    'value': 'horizontal-margin-size:medium',
                },
                {
                    'text': 'Groot',
                    'value': 'horizontal-margin-size:large',
                },
                {
                    'text': 'Extra groot',
                    'value': 'horizontal-margin-size:extra-large',
                },
            ]
        }
    },

    created()
    {
        // TODO High: Fix code duplication.
        // Automatically give a margin
        if (this.options.margin === undefined && this.options.margin !== '') {
            this.options.margin = 'py-8 md:py-16 size:large';
        }

        // Automatically give a margin
        if (this.options.horizontalMargin === undefined && this.options.horizontalMargin !== '') {
            this.options.horizontalMargin = 'horizontal-margin-size:none';
        }
    }
}

</script>
